var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "row p-3 mt-2 shadow-sm bg-white",
      class: { selected: _vm.auction.subastaId === _vm.selectedAuction },
      attrs: { "data-cy": "file" }
    },
    [
      _c("div", { staticClass: "col-11" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-1 text-center text-primary" },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: "Folio Subasta",
                      expression: "'Folio Subasta'"
                    }
                  ],
                  staticClass: "cursor-pointer",
                  class: { "text-success": _vm.wasCopied },
                  attrs: { "data-cy": "file-number" }
                },
                [_vm._v(" " + _vm._s(_vm.auction.folio) + " ")]
              ),
              _c("b-form-checkbox", {
                attrs: { "data-cy": "select" },
                on: { change: _vm.selectElement },
                model: {
                  value: _vm.auction.selected,
                  callback: function($$v) {
                    _vm.$set(_vm.auction, "selected", $$v)
                  },
                  expression: "auction.selected"
                }
              })
            ],
            1
          ),
          _c("div", { staticClass: "col-10" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-2" },
                [
                  _vm.auctionsStates[_vm.auction.estado]
                    ? _c(
                        "b-badge",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Estado Subasta",
                              expression: "'Estado Subasta'"
                            }
                          ],
                          staticClass: "p-2 font-weight-light",
                          attrs: {
                            pill: "",
                            variant:
                              _vm.auctionsStates[_vm.auction.estado].color
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.auctionsStates[_vm.auction.estado].label
                              ) +
                              " "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              ),
              _c("div", { staticClass: "col-2" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm._f("dateFormat")(_vm.auction.fechaCreacion)) +
                    " "
                )
              ]),
              _c("div", { staticClass: "col-2" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm._f("dateFormat")(_vm.auction.fechaSubasta)) +
                    " "
                )
              ]),
              _c("div", { staticClass: "col-5" }, [
                _vm._v(" " + _vm._s(_vm.auction.gestoraNombre) + " ")
              ]),
              _c("div", { staticClass: "col-1" }, [
                _c("b", [
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("amount")(_vm.auction.valorCambio)) +
                      " "
                  )
                ])
              ])
            ])
          ])
        ])
      ]),
      _c(
        "div",
        { staticClass: "col-1 d-flex justify-center" },
        [
          _vm._t(
            "actions",
            [
              _c("AuctionsOptions", {
                ref: "file-options-" + _vm.auction.id,
                attrs: {
                  auction: _vm.auction,
                  "select-auction": _vm.selectAuction
                },
                on: { "reload-list": _vm.handleReloadList }
              })
            ],
            { auction: _vm.auction }
          )
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }